import React, { Component } from "react";
import {
  Spin,
  PageHeader,
  // Button,
  notification,
  message,
} from "antd";
import AgregarEmpresa from "./AgregarEmpresa/AgregarEmpresa";
import axios from "axios";
import { connect } from "react-redux";
import { seleccionarEmpresa } from "../../../store/actions/empresa";
import AgregarEmpresaBasica from "./AgregarEmpresaBasica/AgregarEmpresaBasica";
import moment from "moment";
import "moment/locale/es";
import AgregarEmpresaBasica2 from "./AgregarEmpresaBasica2/AgregarEmpresaBasica2";
import PagarEmpresa from "../Facturacion/PagarEmpresa/PagarEmpresa";
import { WalletOutlined } from "@ant-design/icons";

moment.locale("es");


class Empresas extends Component {
  state = {
    todasEmpresas: null,
    dominantColors: {},
    modalAgregarEmpresa: false,
    modalAgregarEmpresaBasica: false,
    modalAgregarEmpresaBasica2: false,
    modalPagarEmpresa: false,
    modalPagarEmpresaId: null,
    loading: false,
    isMobile: window.matchMedia("(max-width: 768px)").matches,
  };

  componentDidMount() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    this.consultarEmpresas();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    this.setState({ isMobile });
  };

  handleImageLoad = (empresaId, img) => {
    try {
      const canvas = document.createElement("canvas");
      canvas.width = 40;
      canvas.height = 40;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, 40, 40);
      const data = ctx.getImageData(0, 0, 40, 40).data;
      let r = 0, g = 0, b = 0, count = 0;
      for (let i = 0; i < data.length; i += 4) {
        const a = data[i + 3];
        const lum = (data[i] + data[i + 1] + data[i + 2]) / 3;
        if (a > 100 && lum > 30 && lum < 220) {
          r += data[i];
          g += data[i + 1];
          b += data[i + 2];
          count++;
        }
      }
      if (count > 5) {
        const color = `${Math.round(r / count)}, ${Math.round(g / count)}, ${Math.round(b / count)}`;
        this.setState((prev) => ({
          dominantColors: { ...prev.dominantColors, [empresaId]: color },
        }));
      }
    } catch (e) {
      // CORS u otro error - ignora silenciosamente
    }
  };

  logout() {
    this.props.logout().then(() => {
      this.props.history.push("/login");
    });
  }

  /*seleccionarEmpresa(
    id,
    nombre,
    rfc,
    certificada,
    fechaVencimiento,
    certificadaDM,
    envios,
    fletes,
    complementoDetallista,
    modulosMezcal,
    modulosConsignaciones,
    marbetes,
    equipoMedico,
    taxidermia,
    lotesCaducidades,
    cargarXmlPrevio,
    puntoDeVenta,
    activarPagare,
    duplicarVentas,
    programarRecordatorioCxC,
    cotizadorPorInsumo
  ) {
    if (moment(fechaVencimiento) < moment()) {
      return notification.warning({
        message: "No se puede utilizar esta empresa por falta de pago",
        description:
          "Su tiempo vencio dirigase a facturacion para completar el pago.",
      });
    } else {
      this.props
        .seleccionarEmpresa({
          id,
          nombre,
          rfc,
          certificada,
          certificadaDM,
          envios,
          fletes,
          complementoDetallista,
          modulosMezcal,
          modulosConsignaciones,
          marbetes,
          equipoMedico,
          taxidermia,
          lotesCaducidades,
          cargarXmlPrevio,
          puntoDeVenta,
          activarPagare,
          duplicarVentas,
          programarRecordatorioCxC,
          cotizadorPorInsumo,
        })
        .then((data) => {
          this.setState({ loading: false });
          this.props.history.push("/panel/inicio");
          message.success(nombre);
        })
        .catch((err) => {
          this.setState({ loading: false });
          notification.error({
            message: "Error inesperado",
            description: err.toString(),
          });
        });
    }
  }*/

  seleccionarEmpresa(empresa) {
    const {
      id = empresa._id,
      nombre,
      rfc,
      certificada,
      fechaVencimiento,
      certificadaDM,
      automatica,
      envios,
      embarques,
      fletes,
      complementoDetallista,
      complementoSeriesPersonalizadas,
      insumosXCliente,
      modulosMezcal,
      modulosConsignaciones,
      marbetes,
      equipoMedico,
      taxidermia,
      conteos,
      lotesCaducidades,
      filtrosAvanzadosInsumos,
      cargarXmlPrevio,
      puntoDeVenta,
      activarPagare,
      duplicarVentas,
      programarRecordatorioCxC,
      cotizadorPorInsumo,
      ventaOnline,
      appMovil,
      checadaRemota,
      verificacionFacial,
      logoExiste,
      mensajeError,
      nomina,
      controlAsistencia,
      workbenchRequisiciones,
      mostrarSugerenciasRequisicion,
      crm,
      evaluacionProveedores,
      whatsapp,
      whatsappNumeroPorUsuario,
      escuela,
      moduloCalidad,
      mostrarPdfMovimientosInventario,
      decimalesEmpresa,
      camposCalidad,
      consultarProveedoresOnline,
      quitarImpuestosOpcionalVentas,
      desactivarCargaExcelInsumosVentas,
      prorrateoDesCostos,
      anticipos,
      permitirCambiarClienteVenta,
      permitirCambiarInsumoVenta,
      permitirBajaLotesReemplazoVentas,
      permitirEditarRemisionVenta,
      permitirDividirVentaPorPartidas,
      autorizacionesRapidas,
      moduloWms,
      moduloActivosFijos,
      moduloCMMS,
      moduloHoteleria,
      moduloRMA,
      moduloProduccion,
      moduloBOM,
      transporte,
      portalClientes,
      creditos,
      moduloRMACompras,
      comodatoFechaEntregaObligatoria,
      cerrarPedidos,
      finiquitarPedidos,
      semanaPedidos,
      apartarInsumosPedidos,
      pdfApartadoPedido,
      entregarInsumosPedidos,
      generarRequisicionPedidos,
      importarPedidosIMSS,
      editarCotizacionesTerminadas,
      finiquitarCotizaciones,
      formatoRequerimientoCotizaciones,
      editarTodasLasPolizas,
      verPolizaAlRealizarMovimiento,
      buscadorMenu,
      verComoSistemaOCPorDefecto,
      imprimirObservacionesOCPorDefecto,
      separacionInsumosSimpleOC,
      separacionInsumosPorClienteOC,
      separacionInsumosPorDiaOC,
      complementoPSWPedidos,
      mostrarComplementoPagoFacturas,
      vencimientoDesdeRecepcionFactura,
      preCotizacionIngenieria,
      ordenesMaquila,
      activarEtiquetaEntregaPedido,
      unidadTiempoProduccion,
      altaEmpleadoPorPasos,
    } = empresa;

    if (!logoExiste) {
      return notification.error({
        message: 'No se puede utilizar esta empresa',
        description: mensajeError || 'La imagen del logo no existe en el servidor. Contacte al administrador.',
        duration: 5
      });
    }

    if (moment(fechaVencimiento) < moment()) {
    return notification.warning({
      message: 'No se puede utilizar esta empresa por falta de pago',
      description: 'Su tiempo venció, diríjase a facturación para completar el pago.'
    });
  }

  this.props
    .seleccionarEmpresa({ 
      id, nombre, rfc, certificada, certificadaDM, automatica, envios, embarques, fletes,
      complementoDetallista, complementoSeriesPersonalizadas, insumosXCliente, modulosMezcal, modulosConsignaciones, marbetes,
      equipoMedico, taxidermia, conteos, lotesCaducidades, filtrosAvanzadosInsumos, cargarXmlPrevio,
      puntoDeVenta, activarPagare, duplicarVentas, programarRecordatorioCxC,
      cotizadorPorInsumo, ventaOnline,
      appMovil,
      checadaRemota,
      verificacionFacial,
      nomina,
      controlAsistencia,
      workbenchRequisiciones,
      mostrarSugerenciasRequisicion,
      crm,
      evaluacionProveedores,
      whatsapp,
      whatsappNumeroPorUsuario,
      escuela,
      moduloCalidad,
      mostrarPdfMovimientosInventario,
      decimalesEmpresa,
      camposCalidad,
      consultarProveedoresOnline,
      quitarImpuestosOpcionalVentas,
      desactivarCargaExcelInsumosVentas,
      prorrateoDesCostos,
      anticipos,
      permitirCambiarClienteVenta,
      permitirCambiarInsumoVenta,
      permitirBajaLotesReemplazoVentas,
      permitirEditarRemisionVenta,
      permitirDividirVentaPorPartidas,
      autorizacionesRapidas,
      moduloWms,
      moduloActivosFijos,
      moduloCMMS,
      moduloHoteleria,
      moduloRMA,
      moduloProduccion,
      moduloBOM,
      transporte,
      portalClientes,
      creditos,
      moduloRMACompras,
      comodatoFechaEntregaObligatoria,
      cerrarPedidos,
      finiquitarPedidos,
      semanaPedidos,
      apartarInsumosPedidos,
      pdfApartadoPedido,
      entregarInsumosPedidos,
      generarRequisicionPedidos,
      importarPedidosIMSS,
      editarCotizacionesTerminadas,
      finiquitarCotizaciones,
      formatoRequerimientoCotizaciones,
      editarTodasLasPolizas,
      verPolizaAlRealizarMovimiento,
      buscadorMenu,
      verComoSistemaOCPorDefecto,
      imprimirObservacionesOCPorDefecto,
      separacionInsumosSimpleOC,
      separacionInsumosPorClienteOC,
      separacionInsumosPorDiaOC,
      complementoPSWPedidos,
      mostrarComplementoPagoFacturas,
      vencimientoDesdeRecepcionFactura,
      preCotizacionIngenieria,
      ordenesMaquila,
      activarEtiquetaEntregaPedido,
      unidadTiempoProduccion,
      altaEmpleadoPorPasos,
    })
    .then((data) => {
      this.setState({ loading: false });
      this.props.history.push("/panel/inicio");
      message.success(nombre);
    })
    .catch((err) => {
      this.setState({ loading: false });
      notification.error({
        message: "Error inesperado",
        description: err.toString(),
      });
    });
  }

  consultarEmpresas() {
    this.setState({ loading: true });
    axios
      .post(
        "empresas/selectEmpresas",
        { usuarioPrincipal: this.props.usuarioPrincipal },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
        } else {
          this.setState({ todasEmpresas: res.data });
        }
      })
      .catch((err) => {
        this.setState({ loading: true });
        notification.error({
          message: "Error inesperado",
          description: err.toString(),
           duration: 2.0,
        });
      });
  }

  abrirAgregarEmpresa() {
    this.setState({ modalAgregarEmpresa: true });
  }

  cerrarAgregarEmpresa() {
    this.setState({ modalAgregarEmpresa: false });
    this.consultarEmpresas();
  }

  abrirAgregarEmpresaBasica() {
    this.setState({ modalAgregarEmpresaBasica: true });
  }

  cerrarAgregarEmpresaBasica() {
    this.setState({ modalAgregarEmpresaBasica: false });
    this.consultarEmpresas();
  }

  abrirAgregarEmpresaBasica2() {
    this.setState({ modalAgregarEmpresaBasica2: true });
  }

  cerrarAgregarEmpresaBasica2() {
    this.setState({ modalAgregarEmpresaBasica2: false });
    this.consultarEmpresas();
  }

  abrirPagarEmpresa(id) {
    this.setState({ modalPagarEmpresa: true, modalPagarEmpresaId: id });
  }

  cerrarPagarEmpresa() {
    this.setState({ modalPagarEmpresa: false });
    this.consultarEmpresas();
  }

  render() {
    const extra =
      this.props.tipo === 0 ? (
        <>
          {/* Agregar en momento esperado */}

        {/* <Button
          key="agregarEmpresaBasica"
          type="primary"
          onClick={this.abrirAgregarEmpresaBasica.bind(this)}
        >
          Agregar Empresa Basica
        </Button> */}

          {/*

                {/* <Button
          key="agregarEmpresaBasica2"
          type="primary"
          onClick={this.abrirAgregarEmpresaBasica2.bind(this)}
        >
          Agregar Empresa Basica 2
        </Button>
         
      <Button
        key="agregarEmpresa"
        onClick={this.abrirAgregarEmpresa.bind(this)}
      >
        Agregar Empresa
      </Button> */}
        </>
      ) : null;
    return (
      <>
        <style>{`
          .empresa-card {
            --glow-rgb: 0, 191, 214;
            width: 300px;
            background: #ffffff;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: none;
            cursor: pointer;
            transition: box-shadow 0.25s ease, transform 0.25s ease;
            border: 1px solid #e8e8e8;
            flex-shrink: 0;
            position: relative;
          }
          .empresa-card-border-svg {
            position: absolute;
            top: 0; left: 0;
            width: 100%; height: 100%;
            pointer-events: none;
            z-index: 3;
            opacity: 0;
            transition: opacity 0.3s ease;
            overflow: visible;
          }
          .empresa-card:hover .empresa-card-border-svg {
            opacity: 1;
          }
          .empresa-card-border-rect {
            animation: empresa-border-travel 2.5s linear infinite;
          }
          @keyframes empresa-border-travel {
            from { stroke-dashoffset: 0; }
            to { stroke-dashoffset: -1260; }
          }
          .empresa-card:hover {
            box-shadow: 0 8px 28px rgba(var(--glow-rgb), 0.18);
            transform: translateY(-4px);
          }
          .empresa-card-logo-area {
            height: 180px;
            background: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 20px;
            border-bottom: 1px solid #f0f0f0;
            position: relative;
          }
          .empresa-card-logo-img {
            max-width: 100%;
            max-height: 140px;
            object-fit: contain;
          }
          .empresa-card-initials {
            width: 76px;
            height: 76px;
            background: linear-gradient(135deg, #00BFD6 0%, #0099b0 100%);
            color: #ffffff;
            border-radius: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 26px;
            font-weight: 700;
            letter-spacing: 2px;
            box-shadow: 0 4px 14px rgba(0,191,214,0.35);
          }
          .empresa-card-notif-dot {
            position: absolute;
            top: 12px;
            right: 12px;
            background: #ff4d4f;
            color: #fff;
            font-size: 11px;
            font-weight: 700;
            min-width: 22px;
            height: 22px;
            border-radius: 11px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 6px;
            box-shadow: 0 2px 6px rgba(255,77,79,0.4);
          }
          .empresa-card-body {
            padding: 18px 20px 20px;
          }
          .empresa-card-name {
            font-size: 16px;
            font-weight: 700;
            color: #1c1c1e;
            margin-bottom: 6px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1.3;
            letter-spacing: -0.2px;
          }
          .empresa-card-rfc {
            font-size: 12px;
            color: #8c8c8c;
            display: flex;
            align-items: center;
            gap: 7px;
            margin-bottom: 16px;
            font-family: 'Courier New', monospace;
            letter-spacing: 0.3px;
          }
          .empresa-card-rfc-chip {
            background: #f0f0f0;
            color: #555;
            font-size: 10px;
            font-weight: 700;
            padding: 2px 6px;
            border-radius: 4px;
            font-family: sans-serif;
            letter-spacing: 0.5px;
          }
          .empresa-card-divider {
            height: 1px;
            background: #f2f2f2;
            margin: 0 0 14px 0;
          }
          .empresa-card-footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .empresa-card-tag {
            font-size: 12px;
            font-weight: 600;
            padding: 4px 12px;
            border-radius: 20px;
            letter-spacing: 0.2px;
          }
          .empresa-card-tag--active {
            color: #0a7c4e;
            background: #e6f7f0;
          }
          .empresa-card-tag--expired {
            color: #b71c1c;
            background: #fdecea;
          }
          .empresa-card-arrow {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            background: #f5f5f5;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #aaa;
            font-size: 13px;
            transition: background 0.2s, color 0.2s;
          }
          .empresa-card:hover .empresa-card-arrow {
            background: #00BFD6;
            color: #ffffff;
          }
          .empresa-card-footer-actions {
            display: flex;
            align-items: center;
            gap: 8px;
          }
          .empresa-card-wallet {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            border: 1px solid transparent;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 14px;
            padding: 0;
            position: relative;
            transition: transform 0.14s ease, background 0.2s ease,
              box-shadow 0.2s ease, color 0.2s ease;
          }
          .empresa-card-wallet--ok {
            background: #e2f8fb;
            color: #0e7a8c;
            border-color: #bfeef4;
          }
          .empresa-card-wallet--ok:hover {
            background: #00bfd6;
            color: #ffffff;
            transform: translateY(-1px);
            box-shadow: 0 5px 14px rgba(0, 191, 214, 0.4);
          }
          @keyframes empresa-wallet-glow-due {
            0%, 100% { box-shadow: 0 4px 12px rgba(183, 28, 28, 0.3); }
            50% { box-shadow: 0 4px 20px rgba(183, 28, 28, 0.9); }
          }
          @keyframes empresa-wallet-glow-soon {
            0%, 100% { box-shadow: 0 4px 12px rgba(245, 124, 0, 0.3); }
            50% { box-shadow: 0 4px 20px rgba(245, 124, 0, 0.9); }
          }
          .empresa-card-wallet--due {
            background: linear-gradient(135deg, #ef5350, #c62828);
            color: #ffffff;
            box-shadow: 0 4px 12px rgba(183, 28, 28, 0.34);
            animation: empresa-wallet-glow-due 1.4s ease-in-out infinite;
          }
          .empresa-card-wallet--soon {
            background: linear-gradient(135deg, #ffa726, #f57c00);
            color: #ffffff;
            box-shadow: 0 4px 12px rgba(245, 124, 0, 0.34);
            animation: empresa-wallet-glow-soon 1.4s ease-in-out infinite;
          }
          @media (max-width: 768px) {
            .empresa-card {
              width: 92%;
              margin: 0 auto;
            }
          }
        `}</style>
        <PageHeader
          title="Empresas"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={extra}
        />
        <Spin spinning={false}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              flexDirection: this.state.isMobile ? "column" : "row",
              justifyContent: this.state.isMobile ? "center" : "flex-start",
              alignItems: this.state.isMobile ? "center" : "flex-start",
              gap: "20px",
              padding: "8px 4px",
            }}
          >
            {(this.state.todasEmpresas || []).map((value) => {
              const isExpired = moment(value.fechaVencimiento) < moment();
              const isExpiringSoon =
                !isExpired &&
                moment(value.fechaVencimiento) <= moment().add(5, "days");
              const initials = (value.nombre || "E")
                .split(" ")
                .slice(0, 2)
                .map((w) => w[0])
                .join("")
                .toUpperCase();
              const glowRgb = this.state.dominantColors[value._id] || "0, 191, 214";

              return (
                <div
                  key={value._id}
                  className="empresa-card"
                  style={{ "--glow-rgb": glowRgb }}
                  onClick={() => this.seleccionarEmpresa(value)}
                >
                  <div className="empresa-card-logo-area">
                    {value.logo ? (
                      <img
                        src={value.logo}
                        alt={value.nombre}
                        className="empresa-card-logo-img"
                        onLoad={(e) => this.handleImageLoad(value._id, e.target)}
                      />
                    ) : (
                      <div className="empresa-card-initials">{initials}</div>
                    )}
                    {value.notificacionCount > 0 && (
                      <span className="empresa-card-notif-dot">
                        {value.notificacionCount}
                      </span>
                    )}
                  </div>
                  <div className="empresa-card-body">
                    <div className="empresa-card-name" title={value.nombre}>
                      {value.nombre}
                    </div>
                    <div className="empresa-card-rfc">
                      <span className="empresa-card-rfc-chip">RFC</span>
                      {value.rfc}
                    </div>
                    <div className="empresa-card-divider" />
                    <div className="empresa-card-footer">
                      {isExpired ? (
                        <span className="empresa-card-tag empresa-card-tag--expired">
                          Vencida
                        </span>
                      ) : (
                        <span className="empresa-card-tag empresa-card-tag--active">
                          Activa
                        </span>
                      )}
                      <div className="empresa-card-footer-actions">
                        {this.props.permisoAccesoFacturacionBiwo && (
                          <button
                            type="button"
                            className={`empresa-card-wallet ${
                              isExpired
                                ? "empresa-card-wallet--due"
                                : isExpiringSoon
                                ? "empresa-card-wallet--soon"
                                : "empresa-card-wallet--ok"
                            }`}
                            title={
                              isExpired
                                ? "Pagar facturación vencida"
                                : isExpiringSoon
                                ? "Facturación por vencer (5 días o menos)"
                                : "Facturación"
                            }
                            aria-label="Facturación"
                            onClick={(e) => {
                              e.stopPropagation();
                              this.abrirPagarEmpresa(value._id);
                            }}
                          >
                            <WalletOutlined />
                          </button>
                        )}
                        <div className="empresa-card-arrow">›</div>
                      </div>
                    </div>
                  </div>
                  <svg className="empresa-card-border-svg" aria-hidden="true" style={{ filter: `drop-shadow(0 0 5px rgba(${glowRgb}, 0.9))` }}>
                    <rect
                      className="empresa-card-border-rect"
                      x="2" y="2"
                      rx="14" ry="14"
                      fill="none"
                      stroke={`rgba(${glowRgb}, 1)`}
                      strokeWidth="3"
                      strokeDasharray="90 1200"
                      style={{ width: 'calc(100% - 4px)', height: 'calc(100% - 4px)' }}
                    />
                  </svg>
                </div>
              );
            })}
          </div>
        </Spin>
        <AgregarEmpresa
          visible={this.state.modalAgregarEmpresa}
          cerrarAgregarEmpresa={this.cerrarAgregarEmpresa.bind(this)}
        />
        <AgregarEmpresaBasica
          visible={this.state.modalAgregarEmpresaBasica}
          cerrarAgregarEmpresaBasica={this.cerrarAgregarEmpresaBasica.bind(
            this
          )}
        />
        <AgregarEmpresaBasica2
          visible={this.state.modalAgregarEmpresaBasica2}
          cerrarAgregarEmpresaBasica2={this.cerrarAgregarEmpresaBasica2.bind(
            this
          )}
        />
        <PagarEmpresa
          visible={this.state.modalPagarEmpresa}
          id={this.state.modalPagarEmpresaId}
          cerrarPagarEmpresa={this.cerrarPagarEmpresa.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    usuarioId: state.user.usuarioId,
    usuarioPrincipal: state.user.usuarioPrincipal,
    tipo: state.user.tipo,
    empresaId: state.empresa.id,
    rfc: state.empresa.rfc,
    nombre: state.empresa.nombre,
    permisoAccesoFacturacionBiwo:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a5f8f3ce1819b4170f9e7af"
      )?.activado,
  };
};

export default connect(mapStateToProps, { seleccionarEmpresa })(
  Empresas
);
